import { ROUTES, SESSION_ENDED_REASON } from '@/constants';

/**
 * The /login URL that returns to `returnTo` after sign-in. It uses the same
 * `?to=` param as `<CatchAllNavigate>`, which `authProvider.login` reads.
 * Pass `sessionEnded` to show Login's "session ended" notice.
 */
export const buildLoginPath = (returnTo: string, { sessionEnded = false } = {}): string => {
  const params = new URLSearchParams();
  if (sessionEnded) params.set('reason', SESSION_ENDED_REASON);
  if (returnTo.length > 1 && !returnTo.startsWith(ROUTES.LOGIN)) params.set('to', returnTo);
  const query = params.toString();
  return query ? `${ROUTES.LOGIN}?${query}` : ROUTES.LOGIN;
};
